import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

export interface DropdownOption {
  label: string;
  value: string;
  icon?: string;
  disabled?: boolean;
}

@Component({
  selector: 'acs-button',
  templateUrl: './acs-button.html',
  styleUrls: ['./acs-button.scss']
})
export class AcsButtonComponent {
  @Input() variant: 'primary' | 'secondary' | 'text' | 'danger' = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  
  // Dropdown functionality
  @Input() dropdown: boolean = false;
  @Input() dropdownOptions: DropdownOption[] = [];
  @Input() dropdownPosition: 'left' | 'right' = 'left';
  
  @Output() clicked = new EventEmitter<Event>();
  @Output() dropdownOptionSelected = new EventEmitter<DropdownOption>();
  
  showDropdown = false;

  constructor(private elementRef: ElementRef) {}
  
  onClick(event: Event): void {
    if (!this.disabled && !this.loading) {
      if (this.dropdown) {
        this.toggleDropdown();
      } else {
        this.clicked.emit(event);
      }
    }
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  onDropdownOptionClick(option: DropdownOption, event: Event): void {
    event.stopPropagation();
    if (!option.disabled) {
      this.dropdownOptionSelected.emit(option);
      this.showDropdown = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.dropdown && this.showDropdown) {
      const target = event.target as HTMLElement;
      if (!this.elementRef.nativeElement.contains(target)) {
        this.showDropdown = false;
      }
    }
  }
}
